import classNames from 'classnames'
import { useFavorites } from '@hooks/useFavorites'
import { FaStar, FaRegStar } from 'react-icons/fa'

interface FavoriteButtonProps {
  url: string
  size?: 'sm' | 'md' | 'lg'
  className?: string
}

const FavoriteButton = ({ url, size = 'md', className }: FavoriteButtonProps) => {
  const { isFavorite, toggleFavorite } = useFavorites()
  const favorited = isFavorite(url)

  const sizeClasses = {
    sm: 'p-1.5 text-sm',
    md: 'p-2 text-base',
    lg: 'p-2.5 text-lg',
  }

  const iconSizes = {
    sm: 14,
    md: 18,
    lg: 22,
  }

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()
    toggleFavorite(url)
  }

  return (
    <button
      onClick={handleClick}
      title={favorited ? 'Favorilerden Çıkar' : 'Favorilere Ekle'}
      aria-label={favorited ? 'Favorilerden Çıkar' : 'Favorilere Ekle'}
      className={classNames(
        'rounded-lg transition-all duration-200 hover:scale-110 active:scale-95',
        sizeClasses[size],
        {
          'text-yellow-500 hover:text-yellow-600 dark:text-yellow-400 dark:hover:text-yellow-300':
            favorited,
          'text-gray-400 hover:text-yellow-500 dark:text-gray-500 dark:hover:text-yellow-400':
            !favorited,
        },
        className,
      )}
    >
      {favorited ? (
        <FaStar size={iconSizes[size]} />
      ) : (
        <FaRegStar size={iconSizes[size]} />
      )}
    </button>
  )
}

export default FavoriteButton
